import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axiosInstance from 'src/api/axiosInstance';
// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { getCurrentProject, getCurrentServer, getMandEndPoint } from 'src/helper/server-address';
import BreadCrumbs from 'src/components/custom-breadcrumbs/breadcrumbs';
import useNavigateErrorHandler from 'src/hooks/useNavigateErrorHandler';
// import CandidateNewEditForm from '../candidate-new-edit-form';
import { fetchEncryptedToken } from 'src/utils/encryptUtils';
import CandUnderReviewEditForm from '../cand_under-review-edit-form';

export default function CandUnderReviewEditView({ id }) {
  const token = sessionStorage.getItem('token');
  const settings = useSettingsContext();
  const [currentCand, setCurrentCand] = useState(null);
  const [currentCandPrefLoc, setCurrentCandPrefLoc] = useState([]);
  const [currentCandEduDtl, setCurrentCandEduDtl] = useState([]);
  const [currentCandSkils, setCurrentCandSkills] = useState([]);
  const [currentCandCertDtl, setCurrentCandCertDtl] = useState([]);
  const [currentCandExpDtl, setCurrentCandExpDtl] = useState([]);
  const [currentCandRefDtl, setCurrentCandRefDtl] = useState([]);
  const handleApiError = useNavigateErrorHandler();
  const [activeStep, setActiveStep] = useState(0);

  const getCand = useCallback(async() => {
    const encryptedId = await fetchEncryptedToken(id, token);
    if (!encryptedId) throw new Error('Failed to encrypt ID');

    axiosInstance
      .get(
        `/rest/candidate/singleCandDetails/${encryptedId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setCurrentCand(res.data.candidate);
        setCurrentCandPrefLoc(res.data.preferredLocations);
        setCurrentCandEduDtl(res.data.educationDetails);
        setCurrentCandSkills(res.data.skillDetails);
        setCurrentCandExpDtl(res.data.expDetails);
        setCurrentCandCertDtl(res.data.certifications);
        setCurrentCandRefDtl(res.data.refDetails);
      })
      .catch((error) => {
        handleApiError(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    setCurrentCand,
    setCurrentCandPrefLoc,
    setCurrentCandEduDtl,
    setCurrentCandSkills,
    setCurrentCandExpDtl,
    setCurrentCandCertDtl,
    setCurrentCandRefDtl,
    id,
    token,
  ]);

  useEffect(() => {
    getCand();
  }, [id, getCand]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <BreadCrumbs heading="Under Review Candidates" />

      <CandUnderReviewEditForm
        currentCand={currentCand}
        currentCandPrefLoc={currentCandPrefLoc}
        currentCandEduDtl={currentCandEduDtl}
        currentCandSkils={currentCandSkils}
        currentCandCertDtl={currentCandCertDtl}
        currentCandExpDtl={currentCandExpDtl}
        currentCandRefDtl={currentCandRefDtl}
      />
    </Container>
  );
}
CandUnderReviewEditView.propTypes = {
  id: PropTypes.number,
};
